import { useMemo } from 'react'

export const useAdminProfileSlice = <
  TProfile,
  TAccount,
  TUpdateProfile,
  TChangePassword,
  TVerifyCurrentPassword,
  TVerifyTwoFactorFactor,
  TSetupTwoFactor,
  TVerifyTwoFactor,
  TDisableTwoFactor,
  TRegenerateTwoFactorRecoveryCodes,
  TAcknowledgeTwoFactorRecoveryCodes,
  TLoadPasskeys,
  TRegisterPasskey,
  TRemovePasskey,
>({
  profile,
  account,
  profileLoading,
  updateProfile,
  changePassword,
  verifyCurrentPassword,
  verifyTwoFactorFactor,
  setupTwoFactor,
  verifyTwoFactor,
  disableTwoFactor,
  regenerateTwoFactorRecoveryCodes,
  acknowledgeTwoFactorRecoveryCodes,
  loadPasskeys,
  registerPasskey,
  removePasskey,
}: {
  profile: TProfile
  account: TAccount
  profileLoading: boolean
  updateProfile: TUpdateProfile
  changePassword: TChangePassword
  verifyCurrentPassword: TVerifyCurrentPassword
  verifyTwoFactorFactor: TVerifyTwoFactorFactor
  setupTwoFactor: TSetupTwoFactor
  verifyTwoFactor: TVerifyTwoFactor
  disableTwoFactor: TDisableTwoFactor
  regenerateTwoFactorRecoveryCodes: TRegenerateTwoFactorRecoveryCodes
  acknowledgeTwoFactorRecoveryCodes: TAcknowledgeTwoFactorRecoveryCodes
  loadPasskeys: TLoadPasskeys
  registerPasskey: TRegisterPasskey
  removePasskey: TRemovePasskey
}) =>
  useMemo(
    () => ({
      profile,
      account,
      profileLoading,
      updateProfile,
      changePassword,
      verifyCurrentPassword,
      verifyTwoFactorFactor,
      setupTwoFactor,
      verifyTwoFactor,
      disableTwoFactor,
      regenerateTwoFactorRecoveryCodes,
      acknowledgeTwoFactorRecoveryCodes,
      loadPasskeys,
      registerPasskey,
      removePasskey,
    }),
    [
      account,
      changePassword,
      disableTwoFactor,
      loadPasskeys,
      profile,
      profileLoading,
      registerPasskey,
      acknowledgeTwoFactorRecoveryCodes,
      regenerateTwoFactorRecoveryCodes,
      removePasskey,
      setupTwoFactor,
      updateProfile,
      verifyCurrentPassword,
      verifyTwoFactorFactor,
      verifyTwoFactor,
    ],
  )
